export default "__VITE_ASSET__d4a2aaaa__"